import { useAdParams } from '../../../hooks/useAdParams';

const BOOKING_URL = 'https://nekonosenaka.hot-yoyaku.net/e_repeat/cbe/users?u=s3hm7veyo0&k=mirror&s=c-c-r/15';

export default function Menu() {
  const { appendParams } = useAdParams();
  const bookingUrl = appendParams(BOOKING_URL);

  const approaches = [
    {
      title: '産後美容整体',
      description:
        '産後の繊細なお身体に配慮し、\nやさしい力でポイントをとらえた整体を行います。\n\nカウンセリングでお身体の状態や体調を丁寧に確認し、\nお一人お一人に合わせた施術で身体のバランスを整えていきます。',
      image:
        'https://public.readdy.ai/ai/img_res/edited_a834e7511b11636ca2878c3d52e2be7d_506ea238.jpg',
      position: 'object-center',
    },
    {
      title: '骨盤矯正',
      description:
        '産後の骨盤は緩みやすく、\n歪みが起こりやすい不安定な状態です。\n\n骨盤を正しい位置へ整えることで、\n身体の土台が安定し、姿勢や体型の改善にもつながります。',
      image:
        'https://public.readdy.ai/ai/img_res/edited_901297428c65538a8ebbf1308bae014a_506ea238.jpg',
      position: 'object-[40%]',
    },
    {
      title: 'セルフケア',
      description:
        '整体や矯正で整えた身体を維持するために、\nご自宅でできるセルフケアもお伝えしています。\n\nヨガやピラティスをベースにした簡単なエクササイズで、\n無理なく身体を整えていきます。',
      image:
        'https://public.readdy.ai/ai/img_res/edited_9c6c719338e067ce8e7391c95adbb957_506ea238.jpg',
      position: 'object-[30%]',
    },
  ];

  const faqs = [
    {
      q: '産後骨盤矯正はいつからできますか？',
      a: '産後の1ヶ月検診以降から受けることができます。※帝王切開の場合は、2か月以降からをおすすめしています。',
    },
    {
      q: '産後1年以上経過しているのですが、変化は見られるのでしょうか？',
      a: '産後1年以上でも、もちろん効果は出ますので諦めずにご相談下さい！',
    },
    {
      // Fixed the unterminated string literal and removed stray code.
      q: '子どもを一緒に連れながらでも受けられますか？',
      a: 'もちろんです。施術中はベビーカーやバウンサーをご利用いただけますので、安心してご来店ください。',
    },
  ];

  return (
    <section className="py-10 bg-yellow-50">
      <div className="max-w-md mx-auto px-4">
        <h2 className="text-xl font-bold text-gray-800 text-center mb-2">
          産後の身体を整える3つのアプローチ
        </h2>
        <p className="text-gray-600 text-sm text-center mb-8">
          整体・骨盤矯正・セルフケアで理想の身体へ
        </p>

        <div className="space-y-8">
          {approaches.map((approach, index) => (
            <div key={index}>
              <img
                src={approach.image}
                alt={approach.title}
                className={`w-full h-48 object-cover rounded-lg mb-3 ${approach.position}`}
              />
              <h3 className="text-base font-bold text-gray-800 mb-2 px-1">
                {approach.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm px-1 whitespace-pre-line">
                {approach.description}
              </p>

              {/* セルフケアの下にEMS宣伝 */}
              {index === 2 && (
                <div className="mt-5 bg-pink-50 border border-pink-200 rounded-xl px-4 py-4">
                  <p className="text-gray-500 text-xs mb-2">
                    ※オプションとして、お腹の筋肉や骨盤底筋を鍛えるEMS・フェムケアマシンもご利用いただけます。産後のお腹が戻らない方や、尿漏れが気になる方にもおすすめです。
                  </p>
                  {/* バナーエリア */}
                  <div className="flex gap-2 mt-3">
                    <div className="flex-1 bg-white border border-pink-200 rounded-lg overflow-hidden">
                      <img
                        src="https://static.readdy.ai/image/d50572b1dfc4f7f997ef99fe23e21a49/7a6f6e0393a4fcc99d1844bc1c02242f.jpeg"
                        alt="BIO Trainer バイオトレーナー EMS"
                        className="w-full h-auto object-contain"
                      />
                    </div>
                    <div className="flex-1 bg-white border border-pink-200 rounded-lg overflow-hidden">
                      <img
                        src="https://static.readdy.ai/image/d50572b1dfc4f7f997ef99fe23e21a49/d7f743aa4fbf746dbdbe667b22739325.webp"
                        alt="BODY DOCTOR femfit EMS Kegel Trainer"
                        className="w-full h-auto object-contain"
                      />
                    </div>
                  </div>
                </div>
              )}

              {index < approaches.length - 1 && (
                <div className="border-b border-gray-100 mt-8"></div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-yellow-200 pt-10">

          {/* よくある質問 上CTA */}
          <div className="bg-white border border-orange-200 rounded-xl px-5 py-6 text-center mb-8 shadow-sm">
            <p className="text-[#5C3A1E] font-semibold text-lg leading-relaxed mb-1">
              がんばってきた身体を<br />
              今こそ優しく整えてあげましょう
            </p>
            <p className="text-orange-600 font-bold text-sm mb-3 mt-3">＼初回3,980円／</p>
            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-lime-500 text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-lime-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>今すぐ予約する</span>
            </a>
            <p className="text-gray-500 text-xs mt-2">託児あり・産後1ヶ月〜OK</p>
          </div>

          <h3 className="text-lg font-bold text-gray-800 mb-6 text-center">
            よくある質問
          </h3>
          <div className="divide-y divide-gray-200">
            {faqs.map((faq, index) => (
              <details key={index} className="group">
                <summary className="py-4 cursor-pointer hover:text-orange-600 transition-colors flex items-center justify-between">
                  <span className="font-semibold text-gray-800 text-sm pr-3 flex items-start gap-2">
                    <span className="text-orange-500 font-bold flex-shrink-0">
                      Q.
                    </span>
                    {faq.q}
                  </span>
                  <i className="ri-arrow-down-s-line text-xl text-orange-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                </summary>
                <div className="pb-4 pl-6 text-gray-600 leading-relaxed text-sm">
                  <span className="text-lime-500 font-bold">A.</span> {faq.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
